
class Showcase extends HTMLElement {
  constructor() {
    super();

    const tabs = this.querySelectorAll('.showcase__tablist-item');
    const tabContents = this.querySelectorAll('.showcase__tabcontent');

    function select(el) {
      el.classList.add('selected');
    }
    function unselect(el) {
      el.classList.remove('selected');
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {

        const contentId = this.dataset.contentId;
        const content = document.getElementById(contentId);

        tabContents.forEach(function(content) {
          unselect(content);
        })

        tabs.forEach(function(tab) {
          unselect(tab);
        })

        select(this);
        select(content);
      })
    })
  }
}

customElements.define('ws-showcase', Showcase);